/**
 * Image proxy via wsrv.nl (free, no key needed).
 * Automatically resizes + compresses large images on the fly.
 *
 * @param {string} url - Original image URL
 * @param {object} opts - { w, h, q, output }
 * @returns {string} Proxied URL
 */
export const imgProxy = (url, opts = {}) => {
  if (!url) return url;
  // Skip proxy for already-optimized local assets (favicon, logo192, etc.)
  if (url.startsWith("/") || url.startsWith("data:")) return url;

  const { w = 1200, q = 80, output = "webp" } = opts;
  const params = new URLSearchParams({
    url: url,
    w: String(w),
    q: String(q),
    output: output,
    we: "1", // enlarge if needed
  });
  return `https://wsrv.nl/?${params.toString()}`;
};

/** Preset for card thumbnail (small, fast) */
export const imgThumb = (url) => imgProxy(url, { w: 800, q: 75, output: "webp" });

/** Preset for lightbox fullscreen (higher quality, retina-ready) */
export const imgFull = (url) => imgProxy(url, { w: 2400, q: 88, output: "webp" });
